import React from "react"

import { AnalyticsTab } from "../components/AnalyticsTab"
import { BulkGrantTab } from "../components/BulkGrantTab"
import { ManualOpsTab } from "../components/ManualOpsTab"
import { PoolsTab } from "../components/PoolsTab"
import { PresaleTab } from "../components/PresaleTab"

import { TokenTabType } from "./token.helpers"

/**
 * Tab registry, mirroring `TAB_CONTENT` in bonus2.
 *
 * Kept separate from `token.helpers.ts` so that module stays free of component
 * imports — the formatting helpers are unit-testable without pulling React and
 * the whole component tree into the test.
 */
export const TOKEN_TAB_CONTENT: Record<TokenTabType, React.FC<{ tenant: string }>> = {
  presale: PresaleTab,
  pools: PoolsTab,
  analytics: AnalyticsTab,
  "manual-ops": ManualOpsTab,
  "bulk-grant": BulkGrantTab
}
